import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Progress, Button } from 'components/Ui';
import styles from './styles.scss';

const StartView = ({ addType, startQuiz, questionsQueue, areas }) => (
  <div className={styles.startView}>
    <h1 className={styles.title}>Discover more about your water</h1>
    <div className={styles.progress}>
      <Progress value={(questionsQueue.length * 100) / areas.length} />
    </div>
    <div className={styles.subtitle}>Select your areas of interest:</div>
    <div className={styles.answers}>
      {areas.map((area) => (
        <div className={styles.areas} key={area}>
          <Checkbox key={area} onChange={(e) => addType(e, area)} />
          <span className={styles.area}>{area}</span>
        </div>
      ))}
    </div>
    {questionsQueue.length > 0 && (
      <Button onClick={startQuiz} className={styles.startBtn} text="Start" />
    )}
  </div>
);

StartView.propTypes = {
  addType: PropTypes.func,
  startQuiz: PropTypes.func,
  questionsQueue: PropTypes.array,
  areas: PropTypes.array,
};

export default StartView;
